import React from 'react'

import { setCurrency, unitMode } from '../../../../common/cardUtils'
import { WITHOUT_PRICE } from '../../../../common/constants'
import { useAppSelector, useCameFromAds } from '../../../../common/hooks'
import { showPrices } from '../../../../common/utils'
import { Product } from '../../../../store/data/types'

import { StyledContainerDiscount, StyledCurrency } from './styles/CardPriceInfo.style'
import {
  StyledContainerPricesUnit,
  StyledContainerUnit,
  StyledContainerUnitPrice,
  StyledModeUnit,
  StyledMultipleSellInfo,
  StyledPriceUnit,
  StyledWrapper,
} from './styles/UnitPriceInfo.style'
import { isMultipleUnitSell } from '../../../../common/productUtils'

interface UnitPriceInfoProps {
  mode?: string
  warning: boolean
  product: Product
  handleClick: any
}

const UnitPriceInfo = ({ mode, warning, product, handleClick }: UnitPriceInfoProps) => {
  const { discount, price } = product
  const { merchantCode } = useAppSelector((state) => state.session)
  const cameFromAdsFlag = useCameFromAds()

  const isUnitSelected = mode === unitMode
  const isPromotion = !!discount

  const [firstSupplier] = product.supplierPrices
  const unitPrice = firstSupplier.getMoreForLess
    ? firstSupplier.getMoreForLess.priceWithoutPromotion
    : firstSupplier.price

  const finalUnitPrice = showPrices(merchantCode, cameFromAdsFlag)
    ? setCurrency(unitPrice)
    : WITHOUT_PRICE

  return (
    <StyledContainerUnit
      onClick={handleClick}
      id="unit-selector"
      visible={unitPrice}
      isUnitSelected={isUnitSelected}
      warning={warning}
    >
      <StyledWrapper>
        <StyledModeUnit isUnitSelected={isUnitSelected} warning={warning} visible={unitPrice}>
          Fracionado
        </StyledModeUnit>
        <StyledMultipleSellInfo
          visible={isUnitSelected && isMultipleUnitSell(product, !isUnitSelected)}
        >
          Múltiplo de {product.multipleUnitQuantity} un.
        </StyledMultipleSellInfo>
      </StyledWrapper>
      <StyledContainerPricesUnit>
        <StyledContainerUnitPrice isUnitSelected={isUnitSelected}>
          <StyledCurrency fontSizeMobile={'0.5rem'}>R$</StyledCurrency>
          <StyledPriceUnit isUnitSelected={isUnitSelected} data-testid="unit-price">
            {finalUnitPrice}
          </StyledPriceUnit>
          <span>/un.</span>
          {isPromotion && (
            <StyledContainerDiscount>
              <span>R${setCurrency(price)}</span>
            </StyledContainerDiscount>
          )}
        </StyledContainerUnitPrice>
      </StyledContainerPricesUnit>
    </StyledContainerUnit>
  )
}

export default UnitPriceInfo
